import moment from 'moment';

import * as TYPES from '../constants/types';
import { parseJwt } from '../utils/parseJwt';

const initialState = {
  city: null,
  region: null,
  regions: [],
  regionsLoaded: false,
  initialCity: null,
  error: null,
  cities: [],
  token: localStorage.getItem('token') ?? '',
  name: localStorage.getItem('username') ?? '',
  datetime: moment().toISOString(),
  declarationSigned: false,
  showBotPanel: false,
  showBotPopup: false,
  tokenRefreshing: false,
  settingsLoaded: false,
  initialCityLoaded: false,
  citiesLoaded: false,
  districtsLoaded: false,
  districts: [],
  district: null,
  showAdminBtn: false,
  edniproPopup: {
    app: false,
    web: false,
    app_hide_footer: false,
    web_hide_footer: false,
  },
  edniproUrls: {
    ios: '',
    android: '',
  },
  edniproPopupText: '',
  edniproPopupTitle: '',
  edniproCloseAviableTo: '',
  edniproCooldown: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.GET_SETTINGS_REQUEST:
      return { ...state };

    case TYPES.GET_SETTINGS_SUCCESS: {
      const {
        datetime,
        show_bot_panel,
        show_bot_popup,
        show_admin_btn,
        ednipro_popup,
        ednipro_urls,
        ednipro_popup_text,
        ednipro_popup_title,
        ednipro_close_aviable_to,
        ednipro_cooldown,
        appointment_promo,
      } = action.payload;
      const popupFlags =
        typeof ednipro_popup === 'boolean'
          ? { app: ednipro_popup, web: ednipro_popup, app_hide_footer: ednipro_popup, web_hide_footer: ednipro_popup }
          : {
              app: ednipro_popup?.app ?? false,
              web: ednipro_popup?.web ?? false,
              app_hide_footer: ednipro_popup?.app_hide_footer ?? false,
              web_hide_footer: ednipro_popup?.web_hide_footer ?? false,
            };

      localStorage.setItem('datetime', datetime);

      return {
        ...state,
        datetime,
        declarationSigned: localStorage.getItem('declarationSigned') === 'true',
        showBotPanel: show_bot_panel ?? false,
        showBotPopup: show_bot_popup ?? false,
        showAdminBtn: show_admin_btn ?? false,
        edniproPopup: popupFlags,
        edniproUrls: {
          ios: ednipro_urls?.ios ?? '',
          android: ednipro_urls?.android ?? '',
        },
        edniproPopupText: ednipro_popup_text ?? '',
        edniproPopupTitle: ednipro_popup_title ?? '',
        edniproCloseAviableTo: ednipro_close_aviable_to ?? '',
        edniproCooldown: ednipro_cooldown ?? null,
        appointment_promo: appointment_promo ?? '',
        settingsLoaded: true,
        
      };
    }

    case TYPES.GET_SETTINGS_FAILURE:
      return { ...state, settingsLoaded: true };

    case TYPES.CHANGE_CITY: {
      // TODO: Use real city center position
      const city = {
        ...action.payload,
        position: {
          lat: +action.payload.lat,
          lng: +action.payload.lon,
        },
      };

      localStorage.setItem('cityId', city.id);
      localStorage.removeItem('regionId');
      localStorage.removeItem('districtId');

      return {
        ...state,
        city,
        region: null,
        districts: initialState.districts,
        districtsLoaded: initialState.districtsLoaded,
        district: initialState.district,
      };
    }

    case TYPES.CHANGE_REGION: {
      localStorage.setItem('regionId', action.payload.id);
      localStorage.removeItem('cityId');
      localStorage.removeItem('districtId');

      return {
        ...state,
        region: action.payload,
        city: null,
        districts: initialState.districts,
        districtsLoaded: initialState.districtsLoaded,
        district: initialState.district,
      };
    }

    case TYPES.UPDATE_DISTRICT: {
      if (action.payload) {
        localStorage.setItem('districtId', action.payload.id);
      } else {
        localStorage.removeItem('districtId');
      }

      return { ...state, district: action.payload };
    }

    case TYPES.LOGIN_SUCCESS: {
      const { token, expires_in } = action.payload;
      const { name, declarationSigned, show_admin_btn } = parseJwt(token);

      localStorage.setItem('token', token);
      localStorage.setItem('expiresAt', expires_in * 1000 + Date.now());
      localStorage.setItem('declarationSigned', declarationSigned);
      localStorage.setItem('username', name);

      return { ...state, token, name, declarationSigned, showAdminBtn: show_admin_btn };
    }

    case TYPES.LOGOUT: {
      localStorage.removeItem('token');
      localStorage.removeItem('expiresAt');
      localStorage.removeItem('username');
      localStorage.removeItem('declarationSigned');
      localStorage.removeItem('patientId');

      return { ...state, token: '', name: '', declarationSigned: false, showAdminBtn: false };
    }

    case TYPES.REFRESH_TOKEN_REQUEST: {
      return { ...state, tokenRefreshing: true };
    }

    case TYPES.REFRESH_TOKEN_SUCCESS: {
      const { token, expires_in } = action.payload;

      localStorage.setItem('token', token);
      localStorage.setItem('expiresAt', expires_in * 1000 + Date.now());

      return { ...state, token, tokenRefreshing: false };
    }

    case TYPES.REFRESH_TOKEN_FAILURE:
      return { ...state, tokenRefreshing: false };

    case TYPES.GET_CITIES_REQUEST: {
      return { ...state };
    }

    case TYPES.GET_CITIES_SUCCESS: {
      const cityId = localStorage.getItem('cityId');
      const currentCity = action.payload.data.find((city) => city.id === +cityId);

      if (!currentCity) localStorage.removeItem('cityId');

      return {
        ...state,
        citiesLoaded: true,
        cities: action.payload.data,
        city: currentCity
          ? {
              ...currentCity,
              position: {
                lat: +currentCity.lat,
                lng: +currentCity.lon,
              },
            }
          : null,
      };
    }

    case TYPES.GET_CITIES_FAILURE: {
      return { ...state, citiesLoaded: true, error: action.payload };
    }

    case TYPES.GET_DISTRICTS_REQUEST: {
      return { ...state };
    }

    case TYPES.GET_DISTRICTS_SUCCESS: {
      const districtId = localStorage.getItem('districtId');
      const currentDistrict = action.payload.data.find((district) => district.id === +districtId);

      if (!currentDistrict) localStorage.removeItem('districtId');

      return {
        ...state,
        districtsLoaded: true,
        districts: action.payload.data,
        district: currentDistrict || null,
      };
    }

    case TYPES.GET_DISTRICTS_FAILURE: {
      return { ...state, citiesLoaded: true, error: action.payload };
    }

    case TYPES.SYNC_BOT_REQUEST:
      return state;

    case TYPES.SYNC_BOT_SUCCESS: {
      const popupFlags =
        typeof action.payload.ednipro_popup === 'boolean'
          ? {
              app: action.payload.ednipro_popup,
              web: action.payload.ednipro_popup,
            }
          : {
              app: action.payload.ednipro_popup?.app ?? state.edniproPopup.app,
              web: action.payload.ednipro_popup?.web ?? state.edniproPopup.web,
            };

      return {
        ...state,
        showBotPanel: action.payload.show_bot_panel ?? false,
        showBotPopup: action.payload.show_bot_popup ?? false,
        edniproPopup: popupFlags,
        edniproUrls: {
          ios: action.payload.ednipro_urls?.ios ?? state.edniproUrls.ios,
          android: action.payload.ednipro_urls?.android ?? state.edniproUrls.android,
        },
        edniproPopupText: action.payload.ednipro_popup_text ?? state.edniproPopupText,
        edniproPopupTitle: action.payload.ednipro_popup_title ?? state.edniproPopupTitle,
        edniproCloseAviableTo: action.payload.ednipro_close_aviable_to ?? state.edniproCloseAviableTo,
        edniproCooldown: action.payload.ednipro_cooldown ?? state.edniproCooldown,
        appointment_promo: action.payload.appointment_promo ?? state.appointment_promo,
      };
    }

    case TYPES.SYNC_BOT_FAILURE:
      return { ...state };

    case TYPES.GET_REGIONS_REQUEST:
      return { ...state };

    case TYPES.GET_REGIONS_SUCCESS: {
      const regionId = localStorage.getItem('regionId');
      const currentRegion = regionId
        ? action.payload.data.find((r) => r.id === +regionId)
        : null;

      if (regionId && !currentRegion) localStorage.removeItem('regionId');

      return {
        ...state,
        regionsLoaded: true,
        regions: action.payload.data,
        region: currentRegion || state.region,
      };
    }

    case TYPES.GET_REGIONS_FAILURE:
      return { ...state, regionsLoaded: true };

    case TYPES.GET_INITIAL_CITY_REQUEST:
      return { ...state };

    case TYPES.GET_INITIAL_CITY_SUCCESS:
      return { ...state, initialCity: action.payload?.data, initialCityLoaded: true };

    case TYPES.GET_INITIAL_CITY_FAILURE:
      return { ...state, initialCityLoaded: true, error: action.payload };

    default:
      return state;
  }
};
